import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { Dialog, DialogButton } from "../models/dialog.model";


@Injectable({
    providedIn: "root"
})
export class DynamicDialogService {
    public dialog = new BehaviorSubject<Dialog>(new Dialog("", []));
	public dialogConfirmed$ = new Subject<boolean>();

	private _validationBaseMessage = "Please correct any validation errors before continuing.";
	private _detailedValidationMessage = "Please correct the following validation errors before continuing:<br />"

    private _errorDialog: Dialog = new Dialog("An error has occurred", [new DialogButton("OK", false, () => { return; })]);
    private _notImplementedDialog: Dialog = new Dialog("This function has not yet been implemented.", [new DialogButton("Sorry!", true, () => { return; })]);
    private _formInvalidDialog: Dialog = new Dialog("", [new DialogButton("OK", false, () => { return; })]);
    private _formNotReadyDialog: Dialog = new Dialog("Form is not ready for editing.  Please try again in a few moments.", [new DialogButton("OK", false, () => { return; })]);
    private _dialogNoGIS: Dialog = new Dialog("GIS Services are unavailable and data could not be confirmed.", [new DialogButton("OK", false, () => { return false; })]);
    private _successDialog: Dialog = new Dialog("Success", [new DialogButton("OK", true, () => { return; })]);
    

    getDialog(): Dialog {
        return this.dialog.value;
    }

    onDialogChange(): Observable<Dialog> {
        return this.dialog;
    }

    updateDialog(data: Dialog): void {
        this.dialogConfirmed$.next(false);
        this.dialog.next(data);
    }

    showError(): void {
        this._errorDialog.toggleDialog(true);
        this.updateDialog(this._errorDialog);
    }

	showFormInvalid(validationMessages: string[] = []): void {
		if (validationMessages == null || validationMessages.length == 0) {
			this._formInvalidDialog.message = this._validationBaseMessage;
		} else {
			let msg = this._detailedValidationMessage;
			for (let v = 0; v < validationMessages.length; v++) {
				msg = `${msg}<br />${validationMessages[v]}`;
			}
			this._formInvalidDialog.message = msg;
		}
		this._formInvalidDialog.toggleDialog(true);
        this.updateDialog(this._formInvalidDialog);
    }

    showFormNotReady(): void {
        this._formNotReadyDialog.toggleDialog(true);
        this.updateDialog(this._formNotReadyDialog);
    }

    showGISError(): void {
        this._dialogNoGIS.toggleDialog(true);
        this.updateDialog(this._dialogNoGIS);
    }

    showNotImplemented(): void {
        this._notImplementedDialog.toggleDialog(true);
        this.updateDialog(this._notImplementedDialog);
    }

    showSuccessDialog(): void {
        this._successDialog.toggleDialog(true);
        this.updateDialog(this._successDialog);
    }

    constructor() { }
}
